(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper')
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-template"]) return;
  try {
    
    const getpagi = document.querySelector('.AjaxinatePagination');
    if(typeof(getpagi) !== "undefined" && getpagi !== null){
      document.addEventListener("DOMContentLoaded", function() {
        const elem = getpagi.getAttribute('data-pagination');
        var endlessScroll = new Ajaxinate({
          container: '.AjaxinateLoop',
          pagination: '.AjaxinatePagination',
          loadingText: '<span class="loader-line"></span>',
          method: elem == 'scroll' ? 'scroll' : 'click'
        });
      });
    }
    
  
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
            if (window.SPR && theme.review ) {
              if ($('.shopify-product-reviews-badge').length > 0) {
                return window.SPR.registerCallbacks(), window.SPR.initRatingHandler(), window.SPR.initDomEls(), window.SPR.loadProducts(), window.SPR.loadBadges();
              };
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 500px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-1"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');

document.addEventListener('DOMContentLoaded', function () {
  const checkboxes = document.querySelectorAll('.custom-extra-fields input[type="checkbox"]');
  const priceElement = document.querySelector('.product-single__price');
  const priceElementIncl = document.querySelector('.product-single__price-incl');
  
  // Function to convert a formatted price string to a float
  function parsePrice(priceString) {
    return parseFloat(priceString.replace(/\./g, '').replace(',', '.'));
  }

  // Function to format a number as a price string with thousands separator
  function formatPrice(priceNumber) {
    return priceNumber
      .toFixed(2) // Two decimal places
      .replace('.', ',') // Convert decimal point to a comma
      .replace(/\B(?=(\d{3})+(?!\d))/g, '.'); // Add thousands separator
  }

  const basePrice = parsePrice(priceElement.textContent.replace('€', '')); // Convert the base price to a number

  // Function to update the displayed price
  function updatePrice() {
    let totalPrice = basePrice;
    checkboxes.forEach(function (checkbox) {
      if (checkbox.checked) {
        const optionPrice = parsePrice(checkbox.getAttribute('data-price'));
        totalPrice += optionPrice;
      }
    });
    priceElement.textContent = '€' + formatPrice(totalPrice); // Update the price element
  }

  // Add event listeners to all checkboxes
  checkboxes.forEach(function (checkbox) {
    checkbox.addEventListener('change', updatePrice);
  });

  // Initial price update to account for pre-selected options (if any)
  updatePrice();
});
// document.getElementById('AddToCartForm-template--15888677109862__main').addEventListener('submit', function(event) {
//   event.preventDefault(); // Prevent default form submission

//   var form = event.target;
//   var formData = new FormData(form);

//   // Debug: Log FormData content
//   console.log('FormData Entries:');
//   for (var pair of formData.entries()) {
//     console.log(pair[0] + ': ' + pair[1]);
//   }

//   fetch('/cart/add.js', {
//     method: 'POST',
//     body: formData,
//     headers: {
//       'X-Requested-With': 'XMLHttpRequest'
//     }
//   })
//   .then(response => response.json())
//   .then(data => {
//     console.log('Item added to cart:', data);
//     // Optionally redirect or update the cart UI
//   })
//   .catch(error => {
//     console.error('Error adding to cart:', error);
//   });
// });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-2"]) return;
  try {
    

var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');

// New code to set the product title in the input field
document.addEventListener('DOMContentLoaded', function() {
  var formButton = document.querySelector('.button.globo-formbuilder-open');
  if (formButton) {
    formButton.addEventListener('click', function() {
      // Delay execution to ensure the form is rendered
      setTimeout(function() {
        var productTitle = document.querySelector('h1.product-single__title'); // Adjust selector if necessary
        if (productTitle) {
          var titleValue = productTitle.textContent.trim();
          var inputField = document.querySelector('input[name="text-1"]');
          if (inputField) {
            inputField.value = titleValue;
            inputField.setAttribute('readonly', true);
          }
        }
        var label = document.querySelector('.layout-1-column > label');
        if (label) {
          label.classList.add('gfb__label__filled');
        }
        var productImage = document.querySelector('.photo-image img'); // Updated selector
        if (productImage) {
          var imageSrc = productImage.getAttribute('src');
          var formImage = document.querySelector('.gfb-with-image-img');
          if (formImage) {
            formImage.setAttribute('src', imageSrc);
          }
        }
        // Collect selected checkbox values
        var checkboxes = document.querySelectorAll('.product-extra-fields input[type="checkbox"]:checked');
        var selectedUpgrades = [];
        checkboxes.forEach(function(checkbox, index) {
          selectedUpgrades.push(`Upgrade ${index + 1} - ${checkbox.value}`);
        });

        // Remove existing custom input if present
        var existingCustomInput = document.querySelector('#custom-field');
        if (existingCustomInput) {
          existingCustomInput.closest('.globo-form-control').remove();
        }
        var elementsToRemove = document.querySelectorAll('.globo-form-control.layout-2-column');
        elementsToRemove.forEach(function(element) {
          element.remove();
        });
        // Append custom input field with selected upgrades if any
        if (selectedUpgrades.length > 0) {
          var panel = document.querySelector('.panel.movingIn > div:first-child');
          if (panel) {
            var customInputHTML = `
              <div class="globo-form-control layout-1-column" data-type="text">
                <label for="custom-field" class="material_filled-label globo-label gfb__label-v2 gfb__label__filled">
                  <span class="label-content" data-label="Custom Field">Gekozen opties</span>
                </label>
                <div class="globo-form-input">
                  <input type="text" id="custom-field" name="custom-field" class="material_filled-input" placeholder="" value="${selectedUpgrades.join(', ')}">
                </div>
                <small class="messages"></small>
              </div>
            `;
            panel.insertAdjacentHTML('afterend', customInputHTML); // Insert after the first child
          }
        }
      }, 100);
    });
  }
});


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-template-3"]) return;
  try {
    
document.addEventListener('DOMContentLoaded', function() {
    // Wait for the inputs to be available in the DOM
    setTimeout(function() {
      var startDayInput = document.getElementById('allDates');
      var endDayInput = document.getElementById('endAllDates');
      
      if (startDayInput) {
        startDayInput.placeholder = "Begindatum huren";
      }
      if (endDayInput) {
        endDayInput.placeholder = "Einddatum huren";
      }
    }, 300); // Adjust the timeout if necessary
  });
var initPhotoSwipeFromDOM = function(gallerySelector) {

// parse slide data (url, title, size ...) from DOM elements 
// (children of gallerySelector)
var parseThumbnailElements = function(el) {
  var thumbElements = Array.prototype.slice.call(document.querySelectorAll('.photo-image')),
    numNodes = thumbElements.length,
    items = [],
    figureEl,
    linkEl,
    size,
    item;

  for (var i = 0; i < numNodes; i++) {

    figureEl = thumbElements[i]; // <figure> element
    // include only element nodes 
    if (figureEl.nodeType !== 1) {
      continue;
    }

    linkEl = figureEl.children[0]; // <a> element
    if(linkEl.getAttribute('data-size')){
      size =  linkEl.getAttribute('data-size').split('x') ;
    }else{
      size =  [] ;
    }
    
    

    // create slide object
    item = {
      src: linkEl.getAttribute('href'),
      w: parseInt(size[0], 10),
      h: parseInt(size[1], 10)
    };



    if (figureEl.children.length > 1) {
      // <figcaption> content
      item.title = figureEl.children[1].innerHTML;
    }

    if (linkEl.children.length > 0) {
      // thumbnail element, retrieving thumbnail url
      item.msrc = linkEl.children[0].getAttribute('src');
    }

    item.el = figureEl; // save link to element for getThumbBoundsFn
    items.push(item);
  }

  return items;
};

// find nearest parent element
var closest = function closest(el, fn) {
  return el && (fn(el) ? el : closest(el.parentNode, fn));
};

// triggers when user clicks on thumbnail
var onThumbnailsClick = function(e) {
  e = e || window.event;
  e.preventDefault ? e.preventDefault() : e.returnValue = false;

  var eTarget = e.target || e.srcElement;

  // find root element of slide
  var clickedListItem = closest(eTarget, function(el) {
    return (el.tagName && el.tagName.toUpperCase() === 'FIGURE');
  });

  if (!clickedListItem) {
    return;
  }

  // find index of clicked item by looping through all child nodes
  // alternatively, you may define index via data- attribute
  var clickedGallery = clickedListItem.parentNode,
    childNodes = clickedListItem.parentNode.childNodes,
    numChildNodes = childNodes.length,
    nodeIndex = 0,
    index;

  for (var i = 0; i < numChildNodes; i++) {
    if (childNodes[i].nodeType !== 1) {
      continue;
    }

    if (childNodes[i] === clickedListItem) {
      index = nodeIndex;
      break;
    }
    nodeIndex++;
  }



  if (index >= 0) {
    // open PhotoSwipe if valid index found
    openPhotoSwipe(index, clickedGallery);
  }
  return false;
};

// parse picture index and gallery index from URL (#&pid=1&gid=2)
var photoswipeParseHash = function() {
  var hash = window.location.hash.substring(1),
    params = {};

  if (hash.length < 5) {
    return params;
  }

  var vars = hash.split('&');
  for (var i = 0; i < vars.length; i++) {
    if (!vars[i]) {
      continue;
    }
    var pair = vars[i].split('=');
    if (pair.length < 2) {
      continue;
    }
    params[pair[0]] = pair[1];
  }

  if (params.gid) {
    params.gid = parseInt(params.gid, 10);
  }

  return params;
};

var openPhotoSwipe = function(index, galleryElement, disableAnimation, fromURL) {
  var pswpElement = document.querySelectorAll('.pswp')[0],
    gallery,
    options,
    items;

  items = parseThumbnailElements(galleryElement);

  // define options (if needed)
  options = {
    maxSpreadZoom: 1, 
    bgOpacity: 0.7,
    zoomEl: true,
    history: false,
    pinchToClose: false,
    closeOnScroll: false,

    // define gallery index (for URL)
    galleryUID: galleryElement.getAttribute('data-pswp-uid'),

  };

  // PhotoSwipe opened from URL
  if (fromURL) {
    if (options.galleryPIDs) {
      // parse real index when custom PIDs are used 
      // http://photoswipe.com/documentation/faq.html#custom-pid-in-url
      for (var j = 0; j < items.length; j++) {
        if (items[j].pid == index) {
          options.index = j;
          break;
        }
      }
    } else {
      // in URL indexes start from 1
      options.index = parseInt(index, 10) - 1;
    }
  } else {
    options.index = parseInt(index, 10);
  }

  // exit if index not found
  if (isNaN(options.index)) {
    return;
  }

  if (disableAnimation) {
    options.showAnimationDuration = 0;
  }

  // Pass data to PhotoSwipe and initialize it
  gallery = new PhotoSwipe(pswpElement, PhotoSwipeUI_Default, items, options);
  gallery.init();
};

// loop through all gallery elements and bind events
var galleryElements = document.querySelectorAll(gallerySelector);

for (var i = 0, l = galleryElements.length; i < l; i++) {
  galleryElements[i].setAttribute('data-pswp-uid', i + 1);
  galleryElements[i].onclick = onThumbnailsClick;
}

// Parse URL and open gallery if it contains #&pid=3&gid=1
var hashData = photoswipeParseHash();
if (hashData.pid && hashData.gid) {
  openPhotoSwipe(hashData.pid, galleryElements[hashData.gid - 1], true, true);
}
};

// execute above function
initPhotoSwipeFromDOM('.my-gallery');
// New code to set the product title in the input field
document.addEventListener('DOMContentLoaded', function() {
  var formButton = document.querySelector('.button.globo-formbuilder-open');
  if (formButton) {
    formButton.addEventListener('click', function() {
      // Delay execution to ensure the form is rendered
      setTimeout(function() {
        var elementsToRemove = document.querySelectorAll('.globo-form-control.layout-2-column');
        elementsToRemove.forEach(function(element) {
          element.remove();
        });
        var productTitle = document.querySelector('h1.product-single__title'); // Adjust selector if necessary
        if (productTitle) {
          var titleValue = productTitle.textContent.trim();
          var inputField = document.querySelector('input[name="text-1"]');
          if (inputField) {
            inputField.value = titleValue;
            inputField.setAttribute('readonly', true);
          }
        }
        var label = document.querySelector('.layout-1-column > label');
        if (label) {
          label.classList.add('gfb__label__filled');
        }
        var productImage = document.querySelector('.photo-image img'); // Updated selector
        if (productImage) {
          var imageSrc = productImage.getAttribute('src');
          var formImage = document.querySelector('.gfb-with-image-img');
          if (formImage) {
            formImage.setAttribute('src', imageSrc);
          }
        }
        // Collect selected checkbox values
        var checkboxes = document.querySelectorAll('.product-extra-fields input[type="checkbox"]:checked');
        var selectedUpgrades = [];
        checkboxes.forEach(function(checkbox, index) {
          selectedUpgrades.push(`Upgrade ${index + 1} - ${checkbox.value}`);
        });

        // Collect dates values
        var allDates = document.getElementById('allDates');
        var endAllDates = document.getElementById('endAllDates');
        var selectedDates = [];
        if (allDates && allDates.value.trim() !== '') {
          selectedDates.push(`Begindatum huren - ${allDates.value.trim()}`);
        }
        if (endAllDates && endAllDates.value.trim() !== '') {
          selectedDates.push(`Einddatum huren - ${endAllDates.value.trim()}`);
        }

        // Remove existing custom inputs if present
        var existingUpgradeInput = document.querySelector('#custom-upgrades-field');
        if (existingUpgradeInput) {
          existingUpgradeInput.closest('.globo-form-control').remove();
        }
        var existingDateInput = document.querySelector('#custom-dates-field');
        if (existingDateInput) {
          existingDateInput.closest('.globo-form-control').remove();
        }

        // Append custom input fields with selected upgrades and dates if any
        var panel = document.querySelector('.panel.movingIn > div:first-child');
        if (panel) {
          if (selectedUpgrades.length > 0) {
            var customUpgradeInputHTML = `
              <div class="globo-form-control layout-1-column" data-type="text">
                <label for="custom-upgrades-field" class="material_filled-label globo-label gfb__label-v2 gfb__label__filled">
                  <span class="label-content" data-label="Selected Upgrades">Gekozen opties</span>
                </label>
                <div class="globo-form-input">
                  <input type="text" id="custom-upgrades-field" name="custom-upgrades-field" class="material_filled-input" placeholder="" value="${selectedUpgrades.join(', ')}">
                </div>
                <small class="messages"></small>
              </div>
            `;
            panel.insertAdjacentHTML('afterend', customUpgradeInputHTML); // Insert after the first child
          }

          if (selectedDates.length > 0) {
            var customDateInputHTML = `
              <div class="globo-form-control layout-1-column" data-type="text">
                <label for="custom-dates-field" class="material_filled-label globo-label gfb__label-v2 gfb__label__filled">
                  <span class="label-content" data-label="Rental Dates">Rental Dates</span>
                </label>
                <div class="globo-form-input">
                  <input type="text" id="custom-dates-field" name="custom-dates-field" class="material_filled-input" placeholder="" value="${selectedDates.join(', ')}">
                </div>
                <small class="messages"></small>
              </div>
            `;
            panel.insertAdjacentHTML('afterend', customDateInputHTML); // Insert after the first child
          }
        }
      }, 100);
    });
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["timeline"] && !window.DesignMode) return;
  try {
    
  !function(){function e(e){this.element=e,this.blocks=this.element.getElementsByClassName("js-cd-block"),this.images=this.element.getElementsByClassName("js-cd-img"),this.contents=this.element.getElementsByClassName("js-cd-content"),this.offset=.8,this.hideBlocks()}e.prototype.hideBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.blocks[e].getBoundingClientRect().top>window.innerHeight*t.offset&&(t.images[e].classList.add("cd-is-hidden"),t.contents[e].classList.add("cd-is-hidden"))},e.prototype.showBlocks=function(){if(!(!1 in document.documentElement))for(var e,t=this,s=0;s<this.blocks.length;s++)e=s,t.contents[e].classList.contains("cd-is-hidden")&&t.blocks[e].getBoundingClientRect().top<=window.innerHeight*t.offset&&(t.images[e].classList.add("or-timeline__img--bounce-in"),t.contents[e].classList.add("or-timeline__content--bounce-in"),t.images[e].classList.remove("cd-is-hidden"),t.contents[e].classList.remove("cd-is-hidden"))};var t,s=document.getElementsByClassName("js-or-timeline"),n=[],i=!1;if(s.length>0){for(var o=0;o<s.length;o++)t=o,n.push(new e(s[t]));window.addEventListener("scroll",function(e){i||(i=!0,window.requestAnimationFrame?window.requestAnimationFrame(c):setTimeout(c,250))})}function c(){n.forEach(function(e){e.showBlocks()}),i=!1}}();

  } catch(e) { console.error(e); }
})();
})();
